import BulkItem from './BulkItem';
import { AnalyticsGroupBy } from './AnalyticsRequest';

// TODO: these @sprinklr/display-builder imports need to go away
import { isNumBetween } from '@sprinklr/display-builder/utils/Number/NumberUtils';
import { colors } from '@sprinklr/display-builder/components/spaceKit';

export default class InsightsItem extends BulkItem {
    private color: string;

    constructor(id: string, name: string, color?: string) {
        super(id, name);

        this.color = color;
    }

    // Code used to be AnalyticsService.  Saving for posterity until
    // we can find a use-case for InsightsItem
    //
    // const hasScore = !!dataSet.metrics.find(
    //     metric => experienceScoreMetrics.indexOf(metric.name) !== -1
    // );
    // const isInsight = !!request.filters.find(
    //     filter => filter.dimensionName === 'HIERARCHY_ID'
    // );

    static canCreate(groupBy: AnalyticsGroupBy): boolean {
        switch (groupBy?.dimensionName as any) {
            case 'NLP_DOC_POLARITY_SCORE':
                return true;
        }

        return false;
    }

    static create(id: string, name: any, value: number) {
        let color;

        if (isNumBetween(value, 0, 19)) {
            color = colors.sentiments.blush;
        } else if (isNumBetween(value, 20, 39)) {
            color = colors.sentiments.orange;
        } else if (isNumBetween(value, 40, 59)) {
            color = colors.sentiments.sun;
        } else if (isNumBetween(value, 60, 79)) {
            color = '#a4ce30';
        } else if (isNumBetween(value, 80, 100)) {
            color = colors.sentiments.fern;
        }
        return new InsightsItem(id, name, color);
    }

    toString() {
        return this.name === undefined || this.name === null ? '' : this.name;
    }

    toColor(): string {
        return this.color;
    }

    // Construct a InsightsItem from an object, checking for properties first.
    public static fromObject(object: any) {
        const allProps = ['id', 'name', 'color'].every(prop => object.hasOwnProperty(prop));

        if (allProps) {
            return new InsightsItem(object.id, object.name, object.color);
        }
    }
}
